import { render, staticRenderFns } from "./ModalReviewCreate.vue?vue&type=template&id=054540b0&scoped=true"
import script from "./ModalReviewCreate.vue?vue&type=script&lang=js"
export * from "./ModalReviewCreate.vue?vue&type=script&lang=js"
import style0 from "./ModalReviewCreate.vue?vue&type=style&index=0&id=054540b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054540b0",
  null
  
)

export default component.exports